import { Component } from '@angular/core';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';


@Component({
  selector: 'terms-text',
  // templateUrl: './terms.component.html',
  template: `
  <div class="modal" tabindex="-1" id="dialog-terms">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">ShieldSafe Terms and Conditions</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div [innerHTML]="agilityContentModelTerms"></div> 
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>      
  `,
  styleUrl: './terms.component.scss',
  standalone: true
})
export class TermsComponent {

  constructor(
    private readonly directSessionLogic: DirectSessionLogicService
  ) {
  }
  get agilityContentModelTerms(): string {
    return this.directSessionLogic.agilityObjectsSignalValue.legalBody;
  }


}
